// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".changePasswordSubmitButton{width:15%;height:32px}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/screens/changePassword/changePassword.scss"],"names":[],"mappings":"AACA,4BACE,SAAS,CACT,WAAY","file":"changePassword.scss","sourcesContent":["\n.changePasswordSubmitButton{\n  width:15%;\n  height: 32px;\n}"]}]);
// Exports
module.exports = exports;
